import React from 'react';
import { ApplicationView } from '@aha-app/mvc';
import FieldInputs from '../fields/inputs';
import type BaseField from '../../fields/BaseField';
import { type IDataStoreRecordBehaviors } from '../../collaboration/DataStoreRecordBehaviors';
import AttributeRow from './attributes/AttributeRow';
import { type fabric } from 'fabric';

export interface EditFieldProps {
  field: BaseField;
  objects: Array<fabric.Object & IDataStoreRecordBehaviors>;
}

const EditField: React.FC<EditFieldProps> = ({ field, objects }) => {
  const Component = FieldInputs[field.type];
  let input: JSX.Element;
  if (Component) {
    let value = field.valueForObject(objects[0]);
    const sameValue = objects.every(
      object => field.valueForObject(object) === value
    );

    if (!sameValue) {
      value = undefined;
    }

    input = (
      <Component
        field={field}
        objects={objects}
        value={value}
        sameValue={sameValue}
      />
    );
  } else {
    input = (
      <div>
        Could not edit field of type <code>{field.type}</code>
      </div>
    );
  }

  return <AttributeRow title={field.name}>{input}</AttributeRow>;
};

export default ApplicationView(EditField);
